// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__AAIEV","disabled":"link_disabled__FrejE"};